import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc.js';
import timezone from 'dayjs/plugin/timezone.js';

dayjs.extend(utc);
dayjs.extend(timezone);

export const fromUnixTimeFormat = (unixTime) => {
    return dayjs.unix(unixTime).tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss');
}

export const fromUtcTimeFormat = (utcTime) => {
    return dayjs.utc(utcTime).tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss');
}

export const formatMinutes = (minutes) => {
    return dayjs().tz('Asia/Seoul').startOf('day').add(minutes, 'minutes');
};

export const getTotalMinutes = (time) => {
    const startOfDay = dayjs(time).tz('Asia/Seoul').startOf('day');
    return dayjs(time).tz('Asia/Seoul').diff(startOfDay, 'minutes');
};

export const formatUnixTime = (unixTime) => {
    let time;

    if (unixTime.toString().length === 13) {
        time = dayjs(unixTime);
    } else if (unixTime.toString().length === 10) {
        time = dayjs.unix(unixTime);
    } else {
        return 'Invalid Unix Time';
    }

    if (time.isValid()) {
        return time.format('YYYY-MM-DD HH:mm:ss');
    } else {
        return 'Invalid Unix Time';
    }
}
const FULL_DATETIME = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}$/;

// Excel(한국어)이 저장하는 '2026-09-10 오전 9:00:00' 형태를 24시간 표기로 바꾼다.
const normalizeKoreanMeridiem = (str) => str.replace(/(오전|오후)\s*(\d{1,2})(:\d{2})/, (_, meridiem, hour, rest) => {
    const h = (Number(hour) % 12) + (meridiem === '오후' ? 12 : 0);
    return `${String(h).padStart(2, '0')}${rest}`;
});

// CSV 업로드용: unix(초) / 'YYYY-MM-DD HH:mm:ss'(KST) / dayjs·Date 를 모두 unix 초로 변환. 실패 시 0.
export const toUnixTime = (value) => {
    if (value === '' || value === null || value === undefined) return 0;
    if (typeof value === 'number') return value;
    if (dayjs.isDayjs(value) || value instanceof Date) return dayjs(value).unix();

    const str = normalizeKoreanMeridiem(String(value).trim());
    if (/^\d+$/.test(str)) return Number(str);

    try {
        // dayjs.tz 는 파싱 실패 시 RangeError 를 던지므로 예외가 없는 일반 파서로 먼저 확인한다.
        if (!dayjs(str).isValid()) return 0;

        const parsed = dayjs.tz(str, 'Asia/Seoul');
        // dayjs 는 '2026-13-45' 를 다음 해로 넘겨 해석한다. 오타가 조용히 저장되지 않도록 되돌려 비교한다.
        if (FULL_DATETIME.test(str) && parsed.format('YYYY-MM-DD HH:mm:ss') !== str.replace('T', ' ')) return 0;

        return parsed.unix();
    } catch {
        return 0;
    }
};
